import { Component, OnInit, Input } from '@angular/core';
import { ImplementSummaryForEquipmentDetails, SchematicAndObservationPointDetails, WorstEvalForCrackAndNormal, ImplementForEquipmentDetails } from '../equipment-details.model';
import { ImplementDetailsService } from '../../implement-details/implement-details.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-implement-details-header',
  templateUrl: './implement-details-header.component.html',
  styleUrls: ['./implement-details-header.component.scss']
})
export class ImplementDetailsHeaderComponent implements OnInit {

  @Input() Implemetdetails: ImplementSummaryForEquipmentDetails = new ImplementSummaryForEquipmentDetails();
  @Input() evaldetails: ImplementForEquipmentDetails = new ImplementForEquipmentDetails();
  reCalLife : boolean = false;

  constructor(
    private _notification: NotificationsService,
    private _moduleService: ImplementDetailsService
  ) { }

  ngOnInit() {
  }


  getEvalClass(wornPct: number) {
    if (wornPct <= 30) {
      return " WornPctCell evalColorA";
    }
    else if ((wornPct > 30) && (wornPct <= 60)) {
      return " WornPctCell evalColorB";
    }
    else if ((wornPct > 60) && (wornPct <= 80)) {
      return " WornPctCell evalColorC";
    }
    else if (wornPct > 80) {
      return "WornPctCell evalColorX";
    }

    return " WornPctCell noEval";

  }
  recalculateImplementAndComponentsLife()
  {
    this.reCalLife = true;
    console.log("this.Implemetdetails.Id:",this.Implemetdetails.Id);
    this._moduleService.recalculateImplementAndComponentsLife(this.Implemetdetails.Id).subscribe(res => {
      this._notification.success('Re-Calculation Done.');
      this.reCalLife = false;
        window.location.reload();
    });

  }
}
